import { useState } from 'react';

export const usePodIP = () => {
    // Static pod IP address
    const STATIC_POD_IP = '192.168.1.300';
    const [podIP] = useState(STATIC_POD_IP);

    /**
     * Clear the stored pod_ip (kept for compatibility but no longer needed)
     */
    const clearPodIP = () => {
        // No-op since we're using static IP
    };

    return {
        podIP,
        hasPodIP: true, // Always true since we have a static IP
        clearPodIP
    };
};
